/* eslint-disable */
import React, { useEffect } from "react";
import { Box, List, ListItem, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import DataGrid, { SelectColumn, useRowSelection} from 'react-data-grid';
import 'react-data-grid/lib/styles.css';
import EnhancedTableToolbar from '../tableToolbar/tableToolbar';


const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(1),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    gridContent: {
        blockSize: '72vh',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: theme.spacing(1),
    },
    selectCellClassname: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& input': {
            margin: 0,
        }
    }
}));

const CustomDataGrid = (props) => {
    const classes = useStyles();
    // const {columns, rows} = props;
    const [columns, setColumns] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [selectedRows, setSelectedRows] = React.useState(() => new Set());
    // const [searchResult, setSearchResult] = React.useState([]);

    
    const handleOnChange = (event) =>
    {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            let oldRows = props.rows;
            let oldactualUsersData = props.actualUsersData;
            // console.log('oldactualUsersData : ', oldactualUsersData);

            const modifyRows = filterData(oldRows, value);
            const actRows = filterData(oldactualUsersData, value);

            // console.log('actRows : ', actRows);
            // props.setSearchData(actRows);
            // setSearchResult(actRows);
            setRows(modifyRows);
        }
        else {
            props.setSearchData([]);
            // added for resetting checkbox select
            setSelectedRows(new Set());
            // setSearchResult([]);
            setRows(props.rows);
        }
    }

    // const filterData = (rows, searchValue) => {
    //     return rows.filter(item => {
    //         return Object.keys(item).some(key =>
    //             typeof item[key] === 'string' &&
    //             item[key].toLowerCase().includes(searchValue.toLowerCase())
    //         );
    //     });
    // };

    const filterData = (rows, searchValue) => {
        return rows.filter((item) =>
          Object.keys(item).some((key) =>
            typeof item[key] === 'string' && item[key].toLowerCase().includes(searchValue.toLowerCase())
          )
        );
      };
    
  
    
    const handleFilterChangeValue = (filterObj) =>
    {
    }
    const onCheckSelectAll = (event) =>
    {
    }
    const handleEditAll = () =>
    {
        // props.editAllToggle();
    };
    const handleHotelSave = () =>
    {
        // let newFilterList = [...filterListData];
        // props.editAll(newFilterList);
    };
    useEffect(() => {
        if (props.columns && props.columns.findIndex(item => item.key == 'rdg-select-column') == -1) {
            let newCols = props.columns;
            newCols.unshift({
                ...SelectColumn,
                headerCellClass: classes.selectCellClassname,
                cellClass: classes.selectCellClassname
            });
            setColumns(newCols);
            setRows(props.rows);
        }
    }, [props]);
    
    function rowKeyGetter(row) {
        return row.id;
    }

    function rowHeight() {
        // should be based on the content of the row
        return 25 + Math.round(Math.random() * 75);
    }
    function checkboxFormatter(
        { onChange, ...props },
        ref
      ) {
        function handleChange(e) {
            onChange(e.target.checked, (e.nativeEvent).shiftKey);
            // onCheckSelect(e.target.checked, ...props);
        }
        // console.log('ref : ', ref);
        return <input type="checkbox"  ref={ref} {...props} onChange={(e) => handleChange(e)} />;
    }
    const onCheckSelect = (event, ...props) =>
    {
        console.log('event : ', event);
        console.log('props in check : ', ...props);
    }
    function renderCheckbox({ onChange, ...props }) {
        function handleChange(e) {
          onChange(e.target.checked, e.nativeEvent.shiftKey);
        }
      
        return <input type="checkbox" {...props} onChange={handleChange} />;
    }
    // console.log('columns: ', columns);
    return(
        <Box className={classes.boxContent}>
            <EnhancedTableToolbar
                {...props}
                search={search}
                showSendAll={props.showSendAll ? true : false}
                sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                showEdit={props.showEdit ? true : false}
                editButtonTitle={props.showEdit ? true : false}
                handleSearchChange={handleOnChange}
                handleFilterChange={handleFilterChangeValue}
                handleSendEmail={props.handleSendEmail}
                hideAdd={props.hideAdd ? true : false}
                modPermission={props.modPermission}
                disableAdd={props.disableAdd}
                onCheckSelectAll={onCheckSelectAll}
                showEditHotel={props.showEditHotel ? true : false}
                handleEditAll={handleEditAll}
                showHotelToggle={props.showHotelToggle}
                saveHotelButtonTitle={props.saveHotelButtonTitle}
                eventConfigStatus={props.eventConfigStatus}
                compUsed={props.compUsed}
                purchaseUsed={props.purchaseUsed}
            />
            {columns.length > 0 && rows.length > 0 ? 
                <Box className={classes.gridContent}>
                    <DataGrid 
                        columns={columns}
                        rows={rows}
                        rowKeyGetter={rowKeyGetter}
                        className="fill-grid"
                        // rowHeight={rowHeight}
                        // style={{blockSize: '100%'}}
                        selectedRows={selectedRows}
                        renderers={{ renderCheckbox }}
                        onSelectedRowsChange={(e) => {
                            // console.log('e : ', e);
                            setSelectedRows(e);
                            let userIDs = [];
                            for (const item of e) {
                                // console.log(item);
                                const userID = item.substring(item.lastIndexOf('_') + 1);
                                // console.log("->",);
                                userIDs.push(Number(userID))
                            }
                            if (userIDs.length > 0) {
                                if ((userIDs.length == rows.length) && search === '') {
                                    props.setBulkInviteSelected(true);
                                    // props.setSearchData([]);
                                }
                                else {
                                    props.setBulkInviteSelected(false);
                                    const newFilterList1 = [];
                                    let actUsersData = JSON.parse(JSON.stringify(props.actualUsersData));
                                    actUsersData.forEach(rowData => {
                                        let itemData = rowData;
                                        if (userIDs.includes(itemData.actualData.userID))
                                        {
                                            itemData.selected = true;
                                            // console.log('props data -> ', data);
                                            newFilterList1.push(itemData);
                                        }
                                    });
                                    props.setSelectedRecords(JSON.parse(JSON.stringify(newFilterList1)));
                                    // props.setSearchData(newFilterList1);
                                }
                            }
                            else {
                                // props.setSearchData([]);
                                props.setSelectedRecords(JSON.parse(JSON.stringify([])));
                            }
                            // console.log('userID : ', userIDs);
                        }}
                        // renderers={{ checkboxFormatter }}
                        direction={'ltr'}
                    />
                </Box>
            :  (
                <ListItem className={classes.listItemContent}>
                    <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>
                </ListItem>
            )}
        </Box>
    )
}
export default CustomDataGrid;